export enum AFFILIATE_INFO_STATUS {
  ACTIVE = 'A',
  BLOCKED = 'B',
  DELETE = 'D',
}

export interface Affiliate {
  agentId: string;
  affiliateInfo: string;
  emailAddress: string;
  mobileNumber: number;
  rewardPoints: number;
  createdDate: string;
  updatedDate: string;
  status: AFFILIATE_INFO_STATUS;
}

export interface AffiliateDetail {
  affiliateId: string;
  userName?: string;
  lastName: string;
  firstName: string;
  affiliateNameFurigana: string;
  emailAddress: string;
  mobileNumber: string;
  gender: 'M' | 'F' | 'O' | undefined;
  postalCode: string;
  prefecture: string;
  city: string;
  street: string;
  buildingNo: string;
  dob: number | string | undefined;
  image: { alt: string; description: string; path: string } | undefined;
  businessType: string;
  rewardPoints: number;
  ceoName: string;
  ceoNameFurigana: string;
  companyName: string;
  companyAddress: string;
}

export interface AffiliateParams {
  fetch?: number;
  row?: number;
  fromDate?: number;
  toDate?: number;
  search?: string;
}

export interface AffiliatePayload {
  affiliateId: string | number;
  lastName: string;
  firstName: string;
  emailAddress: string;
  mobileNumber: string;
  gender: 'M' | 'F' | 'O' | undefined;
  postalCode: string;
  affiliateNameFurigana: string;
  prefecture: string;
  city: string;
  street: string;
  buildingNo: string;
  dob: number;
  image: string;
  businessType: string;
  ceoName: string;
  ceoNameFurigana: string;
  companyName: string;
  companyAddress: string;
}
